// extracted by mini-css-extract-plugin
module.exports = {"mb3":"style_mb3_2ERmS","center":"style_center_1R_3E"};